// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"status-icon_wrapper__2jSyv","clearIcon":"status-icon_clearIcon__3vZw9","processingIcon":"status-icon_processingIcon__1K9ez","failedIcon":"status-icon_failedIcon__1MBJb"};